/* EVENTS INVOLVING INTEGRATIONS */

export default {
  integrations_modal_visit: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard }) => {
      return {
        dashboardId: dashboard?.id,
        dashboardTitle: dashboard?.title,
      };
    },
  },
  integrations_modal_visit_close: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard }) => {
      return {
        dashboardId: dashboard?.id,
        dashboardTitle: dashboard?.title,
      };
    },
  },
  dashboard_switch_data: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, account }) => {
      return {
        accountId: account?.id,
        dashboardId: dashboard?.id,
        dashboardTitle: dashboard?.title,
      };
    },
  },
};
